import api from './api';

const data = response => response.data;

export const fluxopayApi = {
  overview: () => api.get('/api/fluxopay/overview').then(data),
  account: () => api.get('/api/fluxopay/account').then(data),
  paymentAvailability: () => api.get('/api/fluxopay/payment-availability').then(data),
  transactions: params => api.get('/api/fluxopay/transactions', { params }).then(data),
  transactionProof: id => api.get(`/api/fluxopay/transactions/${id}/proof`).then(data),
  transactionContract: id => api.get(`/api/fluxopay/transactions/${id}/contract`, { responseType: 'blob' }),
  receivables: params => api.get('/api/fluxopay/receivables', { params }).then(data),
  payouts: params => api.get('/api/fluxopay/payouts', { params }).then(data),
  payoutDestination: () =>api.get('/api/fluxopay/payout-destination').then(data),

savePayoutDestination: payload =>api.put('/api/fluxopay/payout-destination', payload).then(data),

requestPayout: payload =>api.post('/api/fluxopay/payouts', payload).then(data),
syncPayout: uuid =>api.post(`/api/fluxopay/payouts/${uuid}/sync`).then(data),
payoutReceipt: uuid =>api.get(`/api/fluxopay/payouts/${uuid}/receipt`).then(data),
reconcilePayouts: () =>api.post('/api/fluxopay/payouts/reconcile').then(data),
ledger: params => api.get('/api/fluxopay/ledger', { params }).then(data),
requestAsaasActivation: payload => api.post('/api/fluxopay/asaas/request-activation', payload).then(data),
patient: id => api.get(`/api/pacientes/${id}`).then(data),
createAsaasOrder: payload => api.post('/api/fluxopay/asaas/orders', payload).then(data),
syncAsaasOrder: uuid => api.post(`/api/fluxopay/asaas/orders/${uuid}/sync`).then(data),
};

export const adminFluxopayApi = {
  overview: () => api.get('/api/admin/fluxopay/overview').then(data),
  accounts: params => api.get('/api/admin/fluxopay/accounts', { params }).then(data),
  transactions: params => api.get('/api/admin/fluxopay/transactions', { params }).then(data),
  transaction: id => api.get(`/api/admin/fluxopay/transactions/${id}`).then(data),
  transactionContract: id => api.get(`/api/admin/fluxopay/transactions/${id}/contract`, { responseType: 'blob' }),
  feeRules: params => api.get('/api/admin/fluxopay/fee-rules', { params }).then(data),
  createFeeRule: payload => api.post('/api/admin/fluxopay/fee-rules', payload).then(data),
  asaasHealth: () => api.get('/api/admin/fluxopay/providers/asaas/health').then(data),
  validateAsaasAccount: (entityId, payload) => api.post(`/api/admin/fluxopay/entities/${entityId}/asaas/validate`, payload).then(data),
  onboardAsaasAccount: (entityId, payload) => api.post(`/api/admin/fluxopay/entities/${entityId}/asaas/onboard`, payload).then(data),
  reconciliations: params => api.get('/api/admin/fluxopay/reconciliations', { params }).then(data),
  reconciliation: id => api.get(`/api/admin/fluxopay/reconciliations/${id}`).then(data),
  webhookEvents: params => api.get('/api/admin/fluxopay/webhook-events', { params }).then(data),
  reconcileAsaas: payload => api.post('/api/admin/fluxopay/reconciliations/asaas', payload).then(data),
};
